/* eslint-disable no-param-reassign */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { manuFactureHead } from './gridComponents/tableHead';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import {
  searchInvoiceByPQR,
  getInvoiceDetailsByInvoiceNum,
  getRebateProgramCode,
  searchInvoiceReportAction,
  setSelectedClient,
  setInvoiceNumber,
  getMaxQuarterForInvoiceSearch,
  getMaxQuarterForFreezeDt,
  setErrorMessagesData,
  dispatchErrors,
  getInvoiceLetterTableData,
  getSaveCoverLetter,
  getInvGridFlag,
  setIsSearchClicked,
  setNoRecordFound,
} from '../store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  quarterFormatter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  navigateToNextCell,
  onCellFocused,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

function RequestInvoiceReport(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [redirect, setRedirect] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const initialFetchDoneRef = React.useRef(false);
  const lastNoRecordSearchCountRef = React.useRef(null);

  const selectedClient = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.selectedClient
  );

  const searchInvoiceRequest = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.searchInvoiceReportRequest
  );
  const invoiceNum = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.invoiceNumber
  );

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  localStorage.setItem('UserDefaultValues', JSON.stringify(UserDefaultValues));

  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));

  const rebateProgramCode = useSelector(
    (state) => state.sharedState.InvoiceReportReducer?.rebateProgramCode?.data
  );

  const invoiceData = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.invoiceDetailsByPQR
  );

  const invoiceDetailsByInvoiceNum = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.invoiceDetailsByInvoiceNum
  );

  const noRecordFound = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.noRecordFound
  );

  const noRecordSearchCount = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.noRecordSearchCount
  );

  const searchClicked = useSelector(
    (state) => state.sharedState.InvoiceReportReducer.searchClicked
  );

  const defaultQtr = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.defaultQtr?.data
  );

  const errorMessagesData = useSelector((state) =>
    state?.sharedState?.InvoiceReportReducer?.errorMessages?.filter((x) => {
      return !x?.includes('No data to print');
    })
  );
  const errors = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.errors
  );

  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );

  const [quarter, setQuarter] = React.useState('');
  const [rebateProgramList, setRebateProgramCode] = React.useState([]);
  const initialErrors = {
    invoiceNum: false,
    rebateProgramCd: false,
    quarter: false,
  };
  const setErrors = (err) => {
    dispatch(dispatchErrors(err));
  };
  const handleErrorMessages = (messages) => {
    setErrorMessages(messages);
    dispatch(setErrorMessagesData(messages));
  };

  React.useEffect(() => {
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Req Invoice Reports';
    }
    setErrors({ ...initialErrors });
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    dispatch(getMaxQuarterForFreezeDt());
    setRedirect(false);
    dispatch(setNoRecordFound(false));
    handleErrorMessages([]);
  }, []);

  React.useEffect(()=>{
    if(!initialFetchDoneRef.current && searchInvoiceRequest?.quarter){
      initialFetchDoneRef.current = true;
      handleInvoiceSearchClick({ showNoRecordError: false });
    }
  },[searchInvoiceRequest])

  // handling refresh functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/request-invoice-report') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  React.useEffect(() => {
    setLoading(false);
  }, [invoiceData]);

  React.useEffect(() => {
    if (defaultQtr) {
      setQuarter(defaultQtr);
      if (!searchInvoiceRequest?.saveButtonEnable) {
        dispatch(
          searchInvoiceReportAction({
            ...searchInvoiceRequest,
            saveButtonEnable: false,
            quarter: defaultQtr,
          })
        );
      }
    }
  }, [defaultQtr]);

  const showInvoiceNotFoundError = (invNumber) => {
    handleErrorMessages([
      `${CONSTANTS.INVOICE_NOT_FOUND}. Invoice: #${invNumber}`,
    ]);
    setErrors({
      ...errors,
      invoiceNum: true,
    });
  };

  const isNoRecordInvoiceResponse = (response) => {
    if (response == null || response === '') return true;
    const data = response?.data ?? response;
    if (typeof data === 'string') {
      const lower = data.toLowerCase();
      return lower.includes('no record') || lower.includes('not found');
    }
    return false;
  };

  const goToInvoiceReportDetails = (invoiceData) => {
    handleErrorMessages([]);
    dispatch(setNoRecordFound(false));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const hasDetailsTab = updateTabs.some(
      (item) => item.navTo === '/invoice-report-details'
    );
    if (!hasDetailsTab) {
      updateTabs.push({
        navTo: '/invoice-report-details',
        value: 'Invoice Report Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
    props.history.push({
      pathname: '/invoice-report-details',
      invoiceDetailsByInvoiceNum: invoiceData,
    });
  };

  React.useEffect(() => {
    setLoading(false);
    const isNewSearchResult =
      lastNoRecordSearchCountRef.current !== null &&
      lastNoRecordSearchCountRef.current !== noRecordSearchCount;
    lastNoRecordSearchCountRef.current = noRecordSearchCount;

    if (noRecordFound && isNewSearchResult) {
      showInvoiceNotFoundError(invoiceNum);
      return;
    }
    if (
      isNewSearchResult &&
      redirect &&
      invoiceDetailsByInvoiceNum &&
      !invoiceDetailsByInvoiceNum?._noRecord &&
      invoiceDetailsByInvoiceNum?.data &&
      typeof invoiceDetailsByInvoiceNum.data !== 'string'
    ) {
      goToInvoiceReportDetails(invoiceDetailsByInvoiceNum.data);
    }
  }, [
    invoiceDetailsByInvoiceNum,
    noRecordFound,
    noRecordSearchCount,
    redirect,
    searchClicked,
  ]);

  React.useEffect(() => {
    let list = [];
    if (rebateProgramCode) {
      if (!_.isEmpty(rebateProgramCode)) {
        list = _.map(rebateProgramCode, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramCode(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProgramCode]);

  const handleInvoiceSearch = (e) => {
    if (e?.target?.name === 'quarter') {
      setQuarter('');
    }
    dispatch(
      searchInvoiceReportAction({
        ...searchInvoiceRequest,
        [e.target.name]: e.target.value,
        ...('planType' in searchInvoiceRequest &&
          e.target.name === 'planType' && { rebateProgramCode: '-1' }),
      })
    );
  };

  const handleInvoiceNumber = (e) => {
    dispatch(setInvoiceNumber(e.target.value));
  };

  const validateInvoicePQRRequest = () => {
    const errorMessage = [];
    const newErrors = { ...initialErrors };
    if (!searchInvoiceRequest?.quarter && !quarter) {
      errorMessage.push('Quarter is required.');
      newErrors.quarter = true;
    }

    if (
      searchInvoiceRequest?.quarter !== '' &&
      !quarterFormatter(searchInvoiceRequest?.quarter)
    ) {
      errorMessage.push(CONSTANTS.QUARTER_FORMAT_ERROR);
      newErrors.quarter = true;
    }
    if (
      !searchInvoiceRequest?.rebateProgramCode === '' ||
      searchInvoiceRequest?.rebateProgramCode === null ||
      searchInvoiceRequest?.rebateProgramCode === '-1'
    ) {
      errorMessage.push('Rebate Program is required.');
      newErrors.rebateProgramCd = true;
    }
    if (defaultPlanType === '' || defaultPlanType === null) {
      errorMessage.push('Plan Type is required.');
      newErrors.planType = true;
    }

    if (errorMessage.length > 0) {
      handleErrorMessages(errorMessage);
      setErrors(newErrors);
      return false;
    }
    handleErrorMessages([]);
    setErrors(initialErrors);
    return true;
  };

  const handleInvoiceSearchClick = ({ showNoRecordError = true } = {}) => {
    if (validateInvoicePQRRequest()) {
      if (!selectedClient) {
        dispatch(setSelectedClient('PQM'));
      }
      let searchInvoiceRequestPayload = { ...searchInvoiceRequest };
      if (
        (searchInvoiceRequest?.quarter !== null ||
          searchInvoiceRequest?.quarter !== '') &&
        quarterFormatter(searchInvoiceRequest?.quarter) &&
        searchInvoiceRequest?.quarter?.split('Q')?.[1]?.length === 2
      ) {
        searchInvoiceRequestPayload = {
          ...searchInvoiceRequest,
          quarter: `${
            searchInvoiceRequest?.quarter?.split('Q')?.[0]
          }Q${new Date().getFullYear().toString().substr(0, 2)}${
            searchInvoiceRequest?.quarter?.split('Q')?.[1]
          }`,
        };
      } else if (!searchInvoiceRequest?.quarter) {
        searchInvoiceRequestPayload.quarter = quarter;
      } else if(!searchInvoiceRequestPayload?.planType|| !searchInvoiceRequestPayload?.rebateProgramCode){
        searchInvoiceRequestPayload.planType = searchInvoiceRequest?.planType || UserDefaultValues?.planTypeCd
        searchInvoiceRequestPayload.rebateProgramCode = searchInvoiceRequest?.rebateProgramCode || UserDefaultValues?.rebateProgramCd
      }
      setLoading(true);
      dispatch(setNoRecordFound(false));
      dispatch(searchInvoiceByPQR(searchInvoiceRequestPayload)).then((result) => {
        setLoading(false);
        if (showNoRecordError && result?.isNoRecord) {
          handleErrorMessages([CONSTANTS.NO_RECORDS_FOUND]);
        }
      });
      dispatch(getSaveCoverLetter(searchInvoiceRequest.rebateProgramCode||UserDefaultValues?.rebateProgramCd));
      dispatch(getInvGridFlag(searchInvoiceRequest.rebateProgramCode||UserDefaultValues?.rebateProgramCd));
    }
  };

  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      // handleErrorMessages(['Invalid Invoice Number']);
      setErrors({
        ...errors,
        invoiceNum: true,
      });
      return false;
    }
    handleErrorMessages([]);
    setErrors(initialErrors);
    return true;
  };
  const handleSearchByInvoiceNumber = async (e) => {
    const errorMessage = [];
    if (invoiceNum) {
      try {
        setLoading(true);
        setRedirect(false);
        const response = await dispatch(
          getInvoiceDetailsByInvoiceNum({ invoiceNum: invoiceNum })
        );
        const responseData = response?.data;
        if (isNoRecordInvoiceResponse(response)) {
          showInvoiceNotFoundError(invoiceNum);
          setLoading(false);
          return;
        }
        if (!responseData || typeof responseData === 'string') {
          showInvoiceNotFoundError(invoiceNum);
          setLoading(false);
          return;
        }
        const rpcForInvSearch = responseData?.rebateProgramCd;
        const obj = {
          rebateProgram: rpcForInvSearch,
          templateTypes: ['COLLECT', 'COVER', 'DISPUTE'],
          invoiceNumber: invoiceNum,
          isSelectedByProQtrManu: false,
        };
        await dispatch(getInvoiceLetterTableData(obj));
        getRebateProgramCodeValue(searchInvoiceRequest.planType);
        await dispatch(
          searchInvoiceReportAction({
            ...searchInvoiceRequest,
            planType: defaultPlanType,
            rebateProgramCode: rpcForInvSearch,
          })
        );
        await dispatch(getSaveCoverLetter(rpcForInvSearch));
        await dispatch(getInvGridFlag(rpcForInvSearch));
        await dispatch(setIsSearchClicked(true));
        goToInvoiceReportDetails(responseData);
      } catch (error) {
        showInvoiceNotFoundError(invoiceNum);
        setLoading(false);
      }
    } else {
      errorMessage.push('Invoice Number is required.');
      setErrors({
        ...errors,
        invoiceNum: true,
      });
      handleErrorMessages(errorMessage);
    }
  };

  const handleOnblurEvent = (name, value) => {
    let errorMessage = [...errorMessagesData];
    if (!value) {
      setErrors({
        ...errors,
        quarter: true,
      });
      errorMessage = errorMessage?.filter((x) => {
        return !x.includes(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI);
      });
      errorMessage.push(constantMessageData.QUARTER_VALUE_REQUIRED);
    } else if (!checkQuarterValidation(value)) {
      errorMessage = errorMessage?.filter((x) => {
        return !x.includes(constantMessageData.QUARTER_VALUE_REQUIRED);
      });
      errorMessage.push(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI);
      setErrors({
        ...errors,
        quarter: true,
      });
    } else {
      errorMessage = errorMessage?.filter((x) => {
        return (
          !x.includes(constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI) &&
          !x.includes(constantMessageData.QUARTER_VALUE_REQUIRED)
        );
      });
      setErrors({
        ...errors,
        quarter: false,
      });
    }
    dispatch(
      searchInvoiceReportAction({
        ...searchInvoiceRequest,
        saveButtonEnable: true,
        quarter: autoFormateDate(value?.toUpperCase()),
      })
    );
    handleErrorMessages(errorMessage);
  };
  const selectByInvoiceNumberClick = (e) => {
    const obj = {
      rebateProgram: searchInvoiceRequest?.rebateProgramCode,
      templateTypes: ['COLLECT', 'COVER', 'DISPUTE'],
      mfgId: e.data.manufacturerId,
      isSelectedByProQtrManu: false,
      invoiceNumber: e.data.invoiveNum,
    };
    setRedirect(true);
    setLoading(true);
    handleErrorMessages([]);
    dispatch(setNoRecordFound(false));
    dispatch(getInvoiceDetailsByInvoiceNum({ invoiceNum: e.data.invoiveNum }));
    dispatch(getInvoiceLetterTableData(obj));
    dispatch(setIsSearchClicked(true));
  };

  React.useEffect(() => {
    if (searchInvoiceRequest.planType|| UserDefaultValues?.planTypeCd) {
      getRebateProgramCodeValue(searchInvoiceRequest.planType||UserDefaultValues?.planTypeCd);
    }
  }, [searchInvoiceRequest.planType,UserDefaultValues?.planTypeCd]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleSelectedClient = useCallback(
    (client) => {
      dispatch(setSelectedClient(client));
      handleErrorMessages([]);
      setErrors(initialErrors);
    },
    [selectedClient]
  );
   const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || invoiceData === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
       // onSelectionChanged({ api: gridApi }); 
      }
    }, [gridApi, invoiceData]);
  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        {loading && <Spinner load={loading} />}

        <>
          <CustomSeparator parent1="Display" parent2="Invoice Reports" />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessages?.filter((x) => {
                  return !x?.includes('No data to print');
                })
              ),
            ]}
          />
          {!fullScreenView && (
            <div className="no-margin">
              <>
                {' '}
                <div className="row mb-2">
                  <div
                    className={`col-12 col-sm-12 ${
                      (selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) !== 'IN'
                        ? 'col-md-7 col-lg-7'
                        : 'col-md-8 col-lg-8'
                    }`}
                  >
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family" id="select_by_label">
                        Select By <span className="mandatory"> *</span>
                      </legend>
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="select_by_label"
                                name="row-radio-buttons-group"
                                defaultValue={selectedClient || UserDefaultValues?.defInvoiceSelectModeCd ||'PQM'}
                                value={selectedClient || UserDefaultValues?.defInvoiceSelectModeCd ||'PQM'}
                              >
                                <FormControlLabel
                                  style={{ marginRight: '0px' }}
                                  value="PQM"
                                  control={
                                    <Radio
                                      onChange={() => {
                                        handleSelectedClient('PQM');
                                      }}
                                    />
                                  }
                                  label="Program, Quarter, Manufacturer"
                                  data-test="PQM"
                                />
                                <FormControlLabel
                                  value="IN"
                                  style={{ marginLeft: '5%' }}
                                  control={
                                    <Radio
                                      onChange={() => {
                                        handleSelectedClient('IN');
                                      }}
                                    />
                                  }
                                  label="Invoice Number"
                                  data-test="IN"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div
                    className={`col-12 col-sm-12  ${
                      (selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) !== 'IN'
                        ? 'col-md-5 col-lg-5'
                        : 'col-md-4 col-lg-4 mt-2'
                    }  frr-radio-40per-width`}
                  >
                    {(selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) !== 'IN' && (
                      <fieldset className="custom-fieldset">
                        <legend
                          className="same-font-family"
                          id="plan_type_label"
                        >
                          Plan Type <span className="mandatory"> *</span>
                        </legend>
                        <div className="form-wrapper p-0 mt-2">
                          <div className="mui-custom-form input-md field-xl">
                            <div className="sub-radio no-margin">
                              <FormControl>
                                <RadioGroup
                                  row
                                  aria-labelledby="plan_type_label"
                                  name="planType"
                                  value={
                                    searchInvoiceRequest.planType ||
                                    defaultPlanType
                                  }
                                  onChange={handleInvoiceSearch}
                                >
                                  <FormControlLabel
                                    value="FD"
                                    control={<Radio />}
                                    label="Medicaid"
                                    data-test="Medicaid"
                                  />
                                  <FormControlLabel
                                    value="COMM"
                                    control={<Radio />}
                                    label="Commercial"
                                    data-test="Commercial"
                                  />
                                  <FormControlLabel
                                    value="ST"
                                    control={<Radio />}
                                    label="State"
                                    data-test="State"
                                  />
                                  <FormControlLabel
                                    value="SUPP"
                                    control={<Radio />}
                                    label="Supplemental"
                                    data-test="Supplemental"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    )}
                    {(selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) === 'IN' && (
                      <fieldset className="custom-fieldset">
                        <legend aria-hidden="true" className="d-none" />
                        <div className="row">
                          <div className="col-12">
                            <div className="mui-custom-form with-select">
                              <TextField
                                label="Invoice Number"
                                data-testid="invoice-number"
                                autoComplete="off"
                                id="invoice-report-number"
                                required
                                fullWidth
                                className={
                                  errorMessages?.length > 0
                                    ? errorMessages?.filter((x) => {
                                        return x.includes('Invoice Number is');
                                      })?.length > 0
                                      ? 'mandate-fields'
                                      : null
                                    : null
                                }
                                error={[
                                  ...new Set(
                                    errorMessages
                                      ?.filter((x) => {
                                        return x.includes('Invoice Number is');
                                      })
                                      ?.map((item) => {
                                        return item;
                                      })
                                  ),
                                ]}
                                helperText={[
                                  ...new Set(
                                    errorMessages
                                      ?.filter((x) => {
                                        return x.includes('Invoice Number is');
                                      })
                                      ?.map((item) => {
                                        return item;
                                      })
                                  ),
                                ]}
                                placeholder=""
                                value={invoiceNum}
                                onChange={handleInvoiceNumber}
                                onKeyPress={isNumber}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{
                                  maxLength: 38,
                                  'aria-labelledby': 'invoice_number_label',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    )}
                  </div>
                </div>
                {!fullScreenView && (selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) !== 'IN' && (
                  <div className="row mb-2">
                    <div className="col-12">
                      <fieldset className="custom-fieldset">
                        <legend aria-hidden="true" className="d-none" />
                        <div className="form-wrapper my-2">
                          <div className="mui-custom-form with-select">
                            <TextField
                              label="Rebate Program"
                              fullWidth
                              select
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                id: 'rebate_program_code',
                              }}
                              // error={errors.rebateProgramCd}
                              required
                              id="rebate_program_code"
                              name="rebateProgramCode"
                              value={
                                (searchInvoiceRequest.rebateProgramCode &&
                                  searchInvoiceRequest.rebateProgramCode !== "-1")
                                    ? searchInvoiceRequest.rebateProgramCode
                                    : defaultRebateCd || "-1"
                              }
                              onChange={handleInvoiceSearch}
                              className={
                                errorMessages?.length > 0
                                  ? errorMessages?.filter((x) => {
                                      return x.includes(
                                        'Rebate Program is required'
                                      );
                                    })?.length > 0
                                    ? 'mandate-fields'
                                    : null
                                  : null
                              }
                              error={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return x.includes(
                                        'Rebate Program is required'
                                      );
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                                errors.rebateProgramCd,
                              ]}
                              helperText={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return x.includes(
                                        'Rebate Program is required'
                                      );
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                              ]}
                            >
                              <MenuItem
                                key=""
                                value="-1"
                                className="frr-dropdown-blank-item"
                              />
                              {rebateProgramCode?.length > 0
                                ? rebateProgramCode.map((item) => {
                                    return (
                                      <MenuItem
                                        key={item.rebateProgramCd}
                                        value={item.rebateProgramCd}
                                      >
                                        {item.rebateProgramCd} {'|'}{' '}
                                        {item.shortDescr}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </TextField>
                          </div>
                          <div className="mui-custom-form input-md">
                            <TextField
                              id="quarter"
                              label="Quarter"
                              fullWidth
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                maxLength: 6,
                              }}
                              // error={errors.quarter}
                              required
                              name="quarter"
                              value={searchInvoiceRequest?.quarter}
                              onChange={handleInvoiceSearch}
                              onBlur={(e) =>
                                handleOnblurEvent('quarter', e.target.value)
                              }
                              className={
                                errorMessages?.length > 0
                                  ? errorMessages?.filter((x) => {
                                      return (
                                        x.includes('Quarter is required') ||
                                        x.includes(
                                          'Please enter a valid quarter and year in'
                                        )
                                      );
                                    })?.length > 0
                                    ? 'mandate-fields'
                                    : null
                                  : null
                              }
                              error={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return (
                                        x.includes('Quarter is required') ||
                                        x.includes(
                                          'Please enter a valid quarter and year in'
                                        )
                                      );
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                                errors.quarter,
                              ]}
                              helperText={[
                                ...new Set(
                                  errorMessages
                                    ?.filter((x) => {
                                      return (
                                        x.includes('Quarter is required') ||
                                        x.includes(
                                          'Please enter a valid quarter and year in'
                                        )
                                      );
                                    })
                                    ?.map((item) => {
                                      return item;
                                    })
                                ),
                              ]}
                            />
                          </div>
                          <div className="mui-custom-form input-md ">
                            <Button
                              className="btn btn-success btn-search mt-20"
                              style={{ marginTop: '20px' }}
                              onClick={() => handleInvoiceSearchClick()}
                              data-testid="check_search_cbi"
                            >
                              <SVGComponent iconName="Icon-search" /> {'  '}
                              Search
                            </Button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                )}
              </>
            </div>
          )}
        </>
      </div>
      {!fullScreenView && (selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) === 'IN' && (
        <div className="row mr-2">
          <div className="col-sm-12">
            <div className="text-right mt-2">
              <Button
                className="btn btn-success btn-search"
                // data-testid="resume-btn"
                onClick={() => handleSearchByInvoiceNumber()}
                data-testid="check_search_cbi"
              >
                <SVGComponent iconName="Icon-search" /> {'  '}
                Search
              </Button>
            </div>
          </div>
        </div>
      )}
      {(selectedClient || UserDefaultValues?.defInvoiceSelectModeCd) === 'PQM' ? (
        <div className="panel tBillPanel-space pb-0">
          <div className="FRR-custom-table tbl-manufacturer-home">
            <TableGrid
              gridHeight={fullScreenView ? '100vh' : 350}
              rowData={invoiceData || []}
              gridCall={onGridReady}
              cellClickedListener={selectByInvoiceNumberClick}
              columnDefs={manuFactureHead}
              data-testid="onEditingStopped"
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenViewClick}
              exportFile
              fileName="Invoice Reports - Manufacturers"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
export default withRouter(RequestInvoiceReport);
